import { render } from "./Footer.vue?vue&type=template&id=df5bf2d8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=df5bf2d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-df5bf2d8"

export default script